//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { createContext } from 'react';
import { type AlertColor } from '@mui/material';

// One line in the persistent status banner.  percent drives a circular bar
// (with the number in its middle); null/undefined shows an indeterminate spin.
export interface StatusEntry {
  text: string;
  percent?: number | null;
}

export interface SnackbarContextValue {
  showSnackbar: (message: string, severity?: AlertColor) => void;
  // Persistent status banner for long-running work (e.g. a load).  Keyed so
  // concurrent tasks each get their own line; pass an entry to show/update a
  // key, or null to dismiss it.  Unlike showSnackbar it does not auto-hide.
  setStatus: (key: string, status: StatusEntry | null) => void;
}

const SnackbarContext = createContext<SnackbarContextValue | null>(null);

export { SnackbarContext };
